import type { FunctionComponent } from "react";
import { DuplicateCampaignModalPartial } from "../../../../partials/admin/menus/campaign/duplicate-campaign-modal.admin.partials";

export const DuplicateCampaignModalAdminScreen: FunctionComponent = () => {
	return <DuplicateCampaignModalPartial />;
};
